import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SelectPayment, setPaymentResponse, setPaymentSuccess } from './store/dataslice';
import PayseraPayment from './PayseraPayment';
import Swal from 'sweetalert2';

const payseraBoxes = [
    {
        label: 'Pagesat përmes UNIREF',
        description: 'Pagesat përmes UNIREF (Thesari)',
        id: 15,
        logo: '/components/rks.png',
        link: '/payment',
        component: 'uniref'
    },
    // {
    //     label: 'Dogana e Kosovës',
    //     description: 'Pagesat për Doganën e Kosovës',
    //     id: 1172,
    //     logo: '/components/dogana.png',
    //     link: '/payment',
    //     component: 'dogana'
    // },    
    {
        label: 'Administrata Tatimore e Kosovës',
        description: 'Pagesat për Administratën Tatimore të Kosovës',
        id: 128,
        logo: '/components/atk.png',
        link: '/payment',
        component: 'atk'
    },
    {
        label: 'Gjobat e trafikut',
        description: 'Pagesa për gjobat në trafik',
        id: 18,
        logo: '/components/policia.png',
        link: '/payment',
        component: 'police'
    },
    {
        label: 'Kompanitë e sigurimeve',
        description: 'Pagesa për kompanitë e sigurimeve',
        id: 3,
        logo: '/components/sigurimet.png',
        link: '/payment',
        component: 'bks'
    },
    {
        label: 'KESCO',
        description: 'Pagesa për faturat e rrymës',
        id: 59,
        logo: '/components/kesco.svg',
        link: '/payment',
        component: 'kesco'
    },
    {
        label: 'KRU Prishtina',
        description: 'Pagesat për KRU Prishtina',
        id: 964,
        logo: '/components/kru-pr.png',
        link: '/payment',
        component: 'kru-pr'
    },
    // {
    //     label: 'VIA eSIM',
    //     description: 'Pagesat për eSIM',
    //     id: 965,
    //     logo: '/components/e-sim.png',
    //     link: '/payment',
    //     component: 'e-sim'
    // },
    {
        label: 'Vala',
        description: 'Pagesat për Vala',
        id: 5,
        logo: '/components/vala.png',
        link: '/payment',
        component: 'vala'
    },
    {
        label: "Prishtina Parking",
        description: "Pagesat për Prishtina Parking",
        id: 6,
        logo: '/components/prishtinaParking.png',
        link: '/payment',
        component: 'prishtina-parking'
    },    
    {
        label: 'Pagesat Komunale',
        description: 'Pagesat Komunale',
        id: 16,
        logo: '/components/rks.png',
        link: '/payment',
        component: 'komunat'
    },
    {
        label: 'Card2Card',
        description: 'Pagesat për Card2Card',
        id: 7,
        logo: '/components/Paysera_Card2Card-Icon.svg',
        link: 'https://kartelat.paysera-ks.com/',
        component: 'otherSource'
    },
    {
        label: 'THIRR',
        description: 'Pagesat për THIRR',
        id: 8,
        logo: '/components/thirr.png',
        link: 'https://thirr.com/',
        component: 'otherSource'
    }
    // {
    //     label: 'KRU Hidroregjioni Jugor',
    //     description: 'Pagesat për KRU Hidroregjioni Jugor',
    //     id: 1015,
    //     logo: '/components/kru-jugor.png',
    //     link: '/payment',
    //     component: 'kru-jugor'
    // },
    // {
    //     label: 'KRU Hidrodrini',
    //     description: 'Pagesat Online',
    //     id: 1017,
    //     logo: '/components/hidrodrini.png',
    //     link: '/payment',
    //     component: 'hidrodrini'
    // },
    // {
    //     label: 'Pagesat tjera',
    //     description: 'Pagesat tjera',
    //     id: 4,
    //     logo: '/components/others.png',
    //     link: '/payment-others',
    //     component: 'others'
    // },
];

const Home = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const PaymentSuccess = useSelector((state) => state.Website.data.PaymentSuccess);
    const AlertMessage = useSelector((state) => state.Website.data.AlertMessage);

    const handleBoxClick = (box) => {
        dispatch(SelectPayment(box))
        dispatch(setPaymentResponse(null));
        if (box.component === "otherSource") {
            window.open(box.link, "_blank", "noopener,noreferrer");
        } else {
            setTimeout(() => {
                navigate(`${box.link}`);
            }, 0);
        }
    }

    useEffect(() => {
        if (PaymentSuccess === true) {
            Swal.fire({
                icon: 'success',
                title: 'Sukses',
                text: "Pagesa është kryer me sukses!",
                // html: `
                //         <a href=${AlertMessage} target="_blank"> Shkarko dëftesën e pagesës</a>
                //     `,
                footer: `${AlertMessage !== null && AlertMessage !== '' ? `<a href=${AlertMessage} class="sweetalert-link" target="_blank">Shkarko dëftesën e pagesës.</a>` : ''}`
                // confirmButtonText: "Në rregull"
            });
            dispatch(setPaymentSuccess(null));
        } else if (PaymentSuccess === false) {
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${AlertMessage !== null ? AlertMessage : 'Pagesa dështoi!'}`,
                // confirmButtonText: "Në rregull"
            });
            dispatch(setPaymentSuccess(null));
        }
    }, [])

    return (
        <div className="paysera-home home-boxes">
            <div className="home-header">
                <h1 className='headline-font'>Paysera Pagesat</h1>
                <span className='home-description body-font'>Zgjidhni njërin nga institucionet për të kryer pagesat online të faturave ose shërbimeve.</span>
            </div>
            <div className="paysera-boxes">
                {payseraBoxes.map(box => (
                    <ButtonBase key={box.id} onClick={() => handleBoxClick(box)}>
                        <div className="box-content paysera-card-surface">
                            <img loading='lazy' src={box.logo} alt={box.label} />
                            {box.label}
                        </div>
                    </ButtonBase>
                ))}
            </div>
            <PayseraPayment />
        </div>
    )
}

export default Home